// src/api/loyalty/loyalty.api.js

import { privateClient } from "../../configs/axiosConfig";

const loyaltyEndpoints = {
  getStampAwardNumber: "/stamp/stampAwardNumber",
  getCardDetail: (id) => `/royalprogram/getcarddetail/${id}`, // 👈 new endpoint

  getCardDesignByWriter: (writerId) =>
    `/royalprogram/getcarddesign/writer/${writerId}`,
};

const loyaltyApi = {
  getStampAwardNumber: async ({ userFrom, userTo }) => {
    try {
      const response = await privateClient.post(
        loyaltyEndpoints.getStampAwardNumber,
        { userFrom, userTo }
      );
      return { response };
    } catch (err) {
      return {
        err: err.response?.data || { message: "Failed to fetch stamp count" },
      };
    }
  },
  getCardDetail: async (id) => {
    try {
      const response = await privateClient.post(
        loyaltyEndpoints.getCardDetail(id)
      );
      return { response };
    } catch (err) {
      return {
        err: err.response?.data || { message: "Failed to fetch card detail" },
      };
    }
  },
  getCardDesignByWriter: async (writerId) => {
    try {
      const { data } = await privateClient.get(
        loyaltyEndpoints.getCardDesignByWriter(writerId)
      );
      return { response: data };
    } catch (err) {
      return {
        err: err.response?.data || {
          message: "Failed to fetch card design by writer",
        },
      };
    }
  },
};

export default loyaltyApi;
